export default __webpack_public_path__ + "static/media/sounds/daze_practice_avatar_alyx.mp3";